import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdateTaxCodeForm from "../../forms/CreateOrUpdateTaxCodeForm";

const CreateTaxCodeModal = ({ open, onClose, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Add Tax Code"
    width="sm"
    loading={loading}
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdateTaxCodeForm loading={loading} />
  </AppModal>
);

export default CreateTaxCodeModal;
